export default __webpack_public_path__ + "static/bathroom-4e397043ae5f206b4b3517817865ac21.webp";